import Cookies from 'js-cookie';
import { fabric } from 'fabric';
import { Common } from '@src/common';

export const setCanvasSetting = (canvasId, { width, height }) => {
  return new fabric.Canvas(canvasId, {
    width,
    height,
    backgroundColor: '#000',
  });
};

export const makeText = ({
  fontFamily = 'YogiyoJalnan',
  strokeWidth = 1,
  textAlign = 'center',
  left = 3,
  top = 3,
  fill = '#fff',
  stroke = '#000',
}) => {
  const isLangJP = Cookies.get(Common.STORAGE_LANG) === Common.CONST_LANG_JA;
  const defaultText = isLangJP
    ? 'ダブルクリックして編集'
    : '더블 클릭하여 편집';

  return new fabric.IText(defaultText, {
    fontFamily,
    strokeWidth,
    top,
    left,
    textAlign,
    fill,
    stroke,
    fontWeight: 700,
    fontSize: 30,
    originX: 'center',
    originY: 'center',
  });
};
